import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { SubdomainService } from "../../_base/subdomain.service";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { Invoice, InvoicePayload } from "../types/invoice";

/**
 * Standalone invoices (`invoices` table). Unrelated to the ToE payment-term driven
 * `toe_invoices` handled by the older InvoiceService in core/toe.
 */
@Injectable({
  providedIn: 'root'
})
export class InvoiceV2Service {
  private baseUrl = environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/invoices`;

  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subDomainService: SubdomainService
  ) {}

  fetchByToe(toeId: number) {
    return this.http.get<{data: Invoice[]}>(
      `${this.baseUrl}/toe/${toeId}`,
      { headers: this.authService.getAuthHeaders() }
    ).pipe(
      map(response => response.data)
    )
  }

  create(toeId: number, payload: InvoicePayload) {
    return this.http.post<{data: Invoice}>(
      `${this.baseUrl}/toe/${toeId}`,
      payload,
      { headers: this.authService.getAuthHeaders() }
    ).pipe(
      map(response => response.data)
    )
  }

  update(id: number, payload: InvoicePayload) {
    return this.http.put<{data: Invoice}>(
      `${this.baseUrl}/${id}`,
      payload,
      { headers: this.authService.getAuthHeaders() }
    ).pipe(
      map(response => response.data)
    )
  }

  delete(id: number) {
    return this.http.delete<{message: string}>(
      `${this.baseUrl}/${id}`,
      { headers: this.authService.getAuthHeaders() }
    )
  }
}
